import { createFileRoute } from '@tanstack/react-router';

import OfficeTaskpaneScreen from '@/screens/office/taskpane';

/**
 * The Office add-in's task pane (KAN-1766). Outside `_app`: it mounts the
 * session and chat providers itself, without the app's sidebar shell.
 */
export const Route = createFileRoute('/office/taskpane')({
  component: OfficeTaskpaneScreen,
});
